import { render, staticRenderFns } from "./OrganizationDetailsPage.vue?vue&type=template&id=33db97a4&scoped=true&"
import script from "./OrganizationDetailsPage.vue?vue&type=script&lang=js&"
export * from "./OrganizationDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDetailsPage.vue?vue&type=style&index=0&id=33db97a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33db97a4",
  null
  
)

export default component.exports